/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ComponentUsageModeConfiguration,
  CreateCustomerCategoryDTO,
  CustomerCategoryBusinessConfigDTO,
  CustomerCategoryDTO,
  CustomerCategoryDocumentDTO,
  CustomerCategoryFieldDTO,
  CustomerCategoryGroupConfigDTO,
  CustomerCategoryLocationDTO,
  CustomerCategoryProductDTO,
  CustomerCategoryUserGroupDTO,
  CustomerType,
  DataProtectionConfiguration,
  EnhancedOnboardingConfigurationDTO,
  EnhancedStepConfigurationDTO,
  OnboardingOverviewConfigurationDTO,
  SubPartType,
  UpdateCustomerCategoryDTO,
  UserCategoryAccessDTO
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getCategoryById = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerCategoryDTO>(
      {url: `/api/customer-categories/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetCategoryByIdQueryKey = (id?: number,) => {
    return [`/api/customer-categories/${id}`] as const;
    }

    
export const getGetCategoryByIdQueryOptions = <TData = Awaited<ReturnType<typeof getCategoryById>>, TError = unknown>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCategoryByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCategoryById>>> = ({ signal }) => getCategoryById(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCategoryById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCategoryByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCategoryById>>>
export type GetCategoryByIdQueryError = unknown


export function useGetCategoryById<TData = Awaited<ReturnType<typeof getCategoryById>>, TError = unknown>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategoryById>>,
          TError,
          Awaited<ReturnType<typeof getCategoryById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCategoryById<TData = Awaited<ReturnType<typeof getCategoryById>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategoryById>>,
          TError,
          Awaited<ReturnType<typeof getCategoryById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCategoryById<TData = Awaited<ReturnType<typeof getCategoryById>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCategoryById<TData = Awaited<ReturnType<typeof getCategoryById>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCategoryByIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const updateCategory = (
    id: number,
    updateCustomerCategoryDTO: UpdateCustomerCategoryDTO,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<CustomerCategoryDTO>(
      {url: `/api/customer-categories/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateCustomerCategoryDTO
    },
      options);
    }
  


export const getUpdateCategoryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCategory>>, TError,{id: number;data: UpdateCustomerCategoryDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCategory>>, TError,{id: number;data: UpdateCustomerCategoryDTO}, TContext> => {

const mutationKey = ['updateCategory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCategory>>, {id: number;data: UpdateCustomerCategoryDTO}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCategory(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof updateCategory>>>
    export type UpdateCategoryMutationBody = UpdateCustomerCategoryDTO
    export type UpdateCategoryMutationError = unknown

    export const useUpdateCategory = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCategory>>, TError,{id: number;data: UpdateCustomerCategoryDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateCategory>>,
        TError,
        {id: number;data: UpdateCustomerCategoryDTO},
        TContext
      > => {

      const mutationOptions = getUpdateCategoryMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const deleteCategory = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<null>(
      {url: `/api/customer-categories/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteCategoryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCategory>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCategory>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteCategory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCategory>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteCategory(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCategory>>>
    
    export type DeleteCategoryMutationError = unknown

    export const useDeleteCategory = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCategory>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCategory>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getDeleteCategoryMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const getUsageModeConfiguration = (
    categoryId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ComponentUsageModeConfiguration>(
      {url: `/api/customer-categories/${categoryId}/usage-mode-configuration`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUsageModeConfigurationQueryKey = (categoryId?: number,) => {
    return [`/api/customer-categories/${categoryId}/usage-mode-configuration`] as const;
    }

    
export const getGetUsageModeConfigurationQueryOptions = <TData = Awaited<ReturnType<typeof getUsageModeConfiguration>>, TError = unknown>(categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsageModeConfiguration>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUsageModeConfigurationQueryKey(categoryId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsageModeConfiguration>>> = ({ signal }) => getUsageModeConfiguration(categoryId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(categoryId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUsageModeConfiguration>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetUsageModeConfigurationQueryResult = NonNullable<Awaited<ReturnType<typeof getUsageModeConfiguration>>>
export type GetUsageModeConfigurationQueryError = unknown


export function useGetUsageModeConfiguration<TData = Awaited<ReturnType<typeof getUsageModeConfiguration>>, TError = unknown>(
 categoryId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsageModeConfiguration>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsageModeConfiguration>>,
          TError,
          Awaited<ReturnType<typeof getUsageModeConfiguration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUsageModeConfiguration<TData = Awaited<ReturnType<typeof getUsageModeConfiguration>>, TError = unknown>(
 categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsageModeConfiguration>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsageModeConfiguration>>,
          TError,
          Awaited<ReturnType<typeof getUsageModeConfiguration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUsageModeConfiguration<TData = Awaited<ReturnType<typeof getUsageModeConfiguration>>, TError = unknown>(
 categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsageModeConfiguration>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetUsageModeConfiguration<TData = Awaited<ReturnType<typeof getUsageModeConfiguration>>, TError = unknown>(
 categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsageModeConfiguration>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetUsageModeConfigurationQueryOptions(categoryId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const updateUsageModeConfiguration = (
    categoryId: number,
    componentUsageModeConfiguration: ComponentUsageModeConfiguration,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<CustomerCategoryDTO>(
      {url: `/api/customer-categories/${categoryId}/usage-mode-configuration`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: componentUsageModeConfiguration
    },
      options);
    }
  


export const getUpdateUsageModeConfigurationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUsageModeConfiguration>>, TError,{categoryId: number;data: ComponentUsageModeConfiguration}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateUsageModeConfiguration>>, TError,{categoryId: number;data: ComponentUsageModeConfiguration}, TContext> => {

const mutationKey = ['updateUsageModeConfiguration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUsageModeConfiguration>>, {categoryId: number;data: ComponentUsageModeConfiguration}> = (props) => {
          const {categoryId,data} = props ?? {};

          return  updateUsageModeConfiguration(categoryId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateUsageModeConfigurationMutationResult = NonNullable<Awaited<ReturnType<typeof updateUsageModeConfiguration>>>
    export type UpdateUsageModeConfigurationMutationBody = ComponentUsageModeConfiguration
    export type UpdateUsageModeConfigurationMutationError = unknown

    export const useUpdateUsageModeConfiguration = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUsageModeConfiguration>>, TError,{categoryId: number;data: ComponentUsageModeConfiguration}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateUsageModeConfiguration>>,
        TError,
        {categoryId: number;data: ComponentUsageModeConfiguration},
        TContext
      > => {

      const mutationOptions = getUpdateUsageModeConfigurationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const getStepComponentsConfiguration = (
    categoryId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<EnhancedStepConfigurationDTO[]>(
      {url: `/api/customer-categories/${categoryId}/step-components`, method: 'GET', signal
    },
      options);
    }
  

export const getGetStepComponentsConfigurationQueryKey = (categoryId?: number,) => {
    return [`/api/customer-categories/${categoryId}/step-components`] as const;
    }

    
export const getGetStepComponentsConfigurationQueryOptions = <TData = Awaited<ReturnType<typeof getStepComponentsConfiguration>>, TError = unknown>(categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStepComponentsConfiguration>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStepComponentsConfigurationQueryKey(categoryId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStepComponentsConfiguration>>> = ({ signal }) => getStepComponentsConfiguration(categoryId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(categoryId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStepComponentsConfiguration>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetStepComponentsConfigurationQueryResult = NonNullable<Awaited<ReturnType<typeof getStepComponentsConfiguration>>>
export type GetStepComponentsConfigurationQueryError = unknown


export function useGetStepComponentsConfiguration<TData = Awaited<ReturnType<typeof getStepComponentsConfiguration>>, TError = unknown>(
 categoryId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStepComponentsConfiguration>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStepComponentsConfiguration>>,
          TError,
          Awaited<ReturnType<typeof getStepComponentsConfiguration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetStepComponentsConfiguration<TData = Awaited<ReturnType<typeof getStepComponentsConfiguration>>, TError = unknown>(
 categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStepComponentsConfiguration>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStepComponentsConfiguration>>,
          TError,
          Awaited<ReturnType<typeof getStepComponentsConfiguration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetStepComponentsConfiguration<TData = Awaited<ReturnType<typeof getStepComponentsConfiguration>>, TError = unknown>(
 categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStepComponentsConfiguration>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetStepComponentsConfiguration<TData = Awaited<ReturnType<typeof getStepComponentsConfiguration>>, TError = unknown>(
 categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStepComponentsConfiguration>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetStepComponentsConfigurationQueryOptions(categoryId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const updateStepComponentsConfiguration = (
    categoryId: number,
    enhancedStepConfigurationDTO: EnhancedStepConfigurationDTO[],
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<CustomerCategoryDTO>(
      {url: `/api/customer-categories/${categoryId}/step-components`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: enhancedStepConfigurationDTO
    },
      options);
    }
  


export const getUpdateStepComponentsConfigurationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStepComponentsConfiguration>>, TError,{categoryId: number;data: EnhancedStepConfigurationDTO[]}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateStepComponentsConfiguration>>, TError,{categoryId: number;data: EnhancedStepConfigurationDTO[]}, TContext> => {

const mutationKey = ['updateStepComponentsConfiguration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateStepComponentsConfiguration>>, {categoryId: number;data: EnhancedStepConfigurationDTO[]}> = (props) => {
          const {categoryId,data} = props ?? {};

          return  updateStepComponentsConfiguration(categoryId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateStepComponentsConfigurationMutationResult = NonNullable<Awaited<ReturnType<typeof updateStepComponentsConfiguration>>>
    export type UpdateStepComponentsConfigurationMutationBody = EnhancedStepConfigurationDTO[]
    export type UpdateStepComponentsConfigurationMutationError = unknown

    export const useUpdateStepComponentsConfiguration = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStepComponentsConfiguration>>, TError,{categoryId: number;data: EnhancedStepConfigurationDTO[]}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateStepComponentsConfiguration>>,
        TError,
        {categoryId: number;data: EnhancedStepConfigurationDTO[]},
        TContext
      > => {

      const mutationOptions = getUpdateStepComponentsConfigurationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const getOverviewConfiguration = (
    categoryId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<OnboardingOverviewConfigurationDTO>(
      {url: `/api/customer-categories/${categoryId}/overview-configuration`, method: 'GET', signal
    },
      options);
    }
  

export const getGetOverviewConfigurationQueryKey = (categoryId?: number,) => {
    return [`/api/customer-categories/${categoryId}/overview-configuration`] as const;
    }

    
export const getGetOverviewConfigurationQueryOptions = <TData = Awaited<ReturnType<typeof getOverviewConfiguration>>, TError = unknown>(categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOverviewConfiguration>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOverviewConfigurationQueryKey(categoryId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOverviewConfiguration>>> = ({ signal }) => getOverviewConfiguration(categoryId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(categoryId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOverviewConfiguration>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetOverviewConfigurationQueryResult = NonNullable<Awaited<ReturnType<typeof getOverviewConfiguration>>>
export type GetOverviewConfigurationQueryError = unknown


export function useGetOverviewConfiguration<TData = Awaited<ReturnType<typeof getOverviewConfiguration>>, TError = unknown>(
 categoryId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOverviewConfiguration>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOverviewConfiguration>>,
          TError,
          Awaited<ReturnType<typeof getOverviewConfiguration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetOverviewConfiguration<TData = Awaited<ReturnType<typeof getOverviewConfiguration>>, TError = unknown>(
 categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOverviewConfiguration>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOverviewConfiguration>>,
          TError,
          Awaited<ReturnType<typeof getOverviewConfiguration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetOverviewConfiguration<TData = Awaited<ReturnType<typeof getOverviewConfiguration>>, TError = unknown>(
 categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOverviewConfiguration>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetOverviewConfiguration<TData = Awaited<ReturnType<typeof getOverviewConfiguration>>, TError = unknown>(
 categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOverviewConfiguration>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetOverviewConfigurationQueryOptions(categoryId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const updateOverviewConfiguration = (
    categoryId: number,
    onboardingOverviewConfigurationDTO: OnboardingOverviewConfigurationDTO,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<CustomerCategoryDTO>(
      {url: `/api/customer-categories/${categoryId}/overview-configuration`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: onboardingOverviewConfigurationDTO
    },
      options);
    }
  


export const getUpdateOverviewConfigurationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOverviewConfiguration>>, TError,{categoryId: number;data: OnboardingOverviewConfigurationDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOverviewConfiguration>>, TError,{categoryId: number;data: OnboardingOverviewConfigurationDTO}, TContext> => {

const mutationKey = ['updateOverviewConfiguration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOverviewConfiguration>>, {categoryId: number;data: OnboardingOverviewConfigurationDTO}> = (props) => {
          const {categoryId,data} = props ?? {};

          return  updateOverviewConfiguration(categoryId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateOverviewConfigurationMutationResult = NonNullable<Awaited<ReturnType<typeof updateOverviewConfiguration>>>
    export type UpdateOverviewConfigurationMutationBody = OnboardingOverviewConfigurationDTO
    export type UpdateOverviewConfigurationMutationError = unknown

    export const useUpdateOverviewConfiguration = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOverviewConfiguration>>, TError,{categoryId: number;data: OnboardingOverviewConfigurationDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateOverviewConfiguration>>,
        TError,
        {categoryId: number;data: OnboardingOverviewConfigurationDTO},
        TContext
      > => {

      const mutationOptions = getUpdateOverviewConfigurationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const updateLocationRequirement = (
    categoryId: number,
    locationId: number,
    customerCategoryLocationDTO: CustomerCategoryLocationDTO,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<CustomerCategoryLocationDTO>(
      {url: `/api/customer-categories/${categoryId}/locations/${locationId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: customerCategoryLocationDTO
    },
      options);
    }
  


export const getUpdateLocationRequirementMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLocationRequirement>>, TError,{categoryId: number;locationId: number;data: CustomerCategoryLocationDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLocationRequirement>>, TError,{categoryId: number;locationId: number;data: CustomerCategoryLocationDTO}, TContext> => {

const mutationKey = ['updateLocationRequirement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLocationRequirement>>, {categoryId: number;locationId: number;data: CustomerCategoryLocationDTO}> = (props) => {
          const {categoryId,locationId,data} = props ?? {};

          return  updateLocationRequirement(categoryId,locationId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateLocationRequirementMutationResult = NonNullable<Awaited<ReturnType<typeof updateLocationRequirement>>>
    export type UpdateLocationRequirementMutationBody = CustomerCategoryLocationDTO
    export type UpdateLocationRequirementMutationError = unknown

    export const useUpdateLocationRequirement = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLocationRequirement>>, TError,{categoryId: number;locationId: number;data: CustomerCategoryLocationDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateLocationRequirement>>,
        TError,
        {categoryId: number;locationId: number;data: CustomerCategoryLocationDTO},
        TContext
      > => {

      const mutationOptions = getUpdateLocationRequirementMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const removeLocationRequirement = (
    categoryId: number,
    locationId: number,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<null>(
      {url: `/api/customer-categories/${categoryId}/locations/${locationId}`, method: 'DELETE'
    },
      options);
    }
  


export const getRemoveLocationRequirementMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeLocationRequirement>>, TError,{categoryId: number;locationId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof removeLocationRequirement>>, TError,{categoryId: number;locationId: number}, TContext> => {

const mutationKey = ['removeLocationRequirement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeLocationRequirement>>, {categoryId: number;locationId: number}> = (props) => {
          const {categoryId,locationId} = props ?? {};

          return  removeLocationRequirement(categoryId,locationId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RemoveLocationRequirementMutationResult = NonNullable<Awaited<ReturnType<typeof removeLocationRequirement>>>
    
    export type RemoveLocationRequirementMutationError = unknown

    export const useRemoveLocationRequirement = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeLocationRequirement>>, TError,{categoryId: number;locationId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeLocationRequirement>>,
        TError,
        {categoryId: number;locationId: number},
        TContext
      > => {

      const mutationOptions = getRemoveLocationRequirementMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const getEnhancedOnboardingConfiguration = (
    categoryId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<EnhancedOnboardingConfigurationDTO>(
      {url: `/api/customer-categories/${categoryId}/enhanced-onboarding`, method: 'GET', signal
    },
      options);
    }
  

export const getGetEnhancedOnboardingConfigurationQueryKey = (categoryId?: number,) => {
    return [`/api/customer-categories/${categoryId}/enhanced-onboarding`] as const;
    }

    
export const getGetEnhancedOnboardingConfigurationQueryOptions = <TData = Awaited<ReturnType<typeof getEnhancedOnboardingConfiguration>>, TError = unknown>(categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnhancedOnboardingConfiguration>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEnhancedOnboardingConfigurationQueryKey(categoryId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEnhancedOnboardingConfiguration>>> = ({ signal }) => getEnhancedOnboardingConfiguration(categoryId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(categoryId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEnhancedOnboardingConfiguration>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetEnhancedOnboardingConfigurationQueryResult = NonNullable<Awaited<ReturnType<typeof getEnhancedOnboardingConfiguration>>>
export type GetEnhancedOnboardingConfigurationQueryError = unknown


export function useGetEnhancedOnboardingConfiguration<TData = Awaited<ReturnType<typeof getEnhancedOnboardingConfiguration>>, TError = unknown>(
 categoryId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnhancedOnboardingConfiguration>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEnhancedOnboardingConfiguration>>,
          TError,
          Awaited<ReturnType<typeof getEnhancedOnboardingConfiguration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetEnhancedOnboardingConfiguration<TData = Awaited<ReturnType<typeof getEnhancedOnboardingConfiguration>>, TError = unknown>(
 categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnhancedOnboardingConfiguration>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEnhancedOnboardingConfiguration>>,
          TError,
          Awaited<ReturnType<typeof getEnhancedOnboardingConfiguration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetEnhancedOnboardingConfiguration<TData = Awaited<ReturnType<typeof getEnhancedOnboardingConfiguration>>, TError = unknown>(
 categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnhancedOnboardingConfiguration>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetEnhancedOnboardingConfiguration<TData = Awaited<ReturnType<typeof getEnhancedOnboardingConfiguration>>, TError = unknown>(
 categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnhancedOnboardingConfiguration>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetEnhancedOnboardingConfigurationQueryOptions(categoryId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const updateEnhancedOnboardingConfiguration = (
    categoryId: number,
    enhancedOnboardingConfigurationDTO: EnhancedOnboardingConfigurationDTO,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<CustomerCategoryDTO>(
      {url: `/api/customer-categories/${categoryId}/enhanced-onboarding`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: enhancedOnboardingConfigurationDTO
    },
      options);
    }
  


export const getUpdateEnhancedOnboardingConfigurationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEnhancedOnboardingConfiguration>>, TError,{categoryId: number;data: EnhancedOnboardingConfigurationDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateEnhancedOnboardingConfiguration>>, TError,{categoryId: number;data: EnhancedOnboardingConfigurationDTO}, TContext> => {

const mutationKey = ['updateEnhancedOnboardingConfiguration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEnhancedOnboardingConfiguration>>, {categoryId: number;data: EnhancedOnboardingConfigurationDTO}> = (props) => {
          const {categoryId,data} = props ?? {};

          return  updateEnhancedOnboardingConfiguration(categoryId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateEnhancedOnboardingConfigurationMutationResult = NonNullable<Awaited<ReturnType<typeof updateEnhancedOnboardingConfiguration>>>
    export type UpdateEnhancedOnboardingConfigurationMutationBody = EnhancedOnboardingConfigurationDTO
    export type UpdateEnhancedOnboardingConfigurationMutationError = unknown

    export const useUpdateEnhancedOnboardingConfiguration = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEnhancedOnboardingConfiguration>>, TError,{categoryId: number;data: EnhancedOnboardingConfigurationDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateEnhancedOnboardingConfiguration>>,
        TError,
        {categoryId: number;data: EnhancedOnboardingConfigurationDTO},
        TContext
      > => {

      const mutationOptions = getUpdateEnhancedOnboardingConfigurationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const updateDocumentRequirement = (
    categoryId: number,
    documentId: number,
    customerCategoryDocumentDTO: CustomerCategoryDocumentDTO,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<CustomerCategoryDocumentDTO>(
      {url: `/api/customer-categories/${categoryId}/documents/${documentId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: customerCategoryDocumentDTO
    },
      options);
    }
  


export const getUpdateDocumentRequirementMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDocumentRequirement>>, TError,{categoryId: number;documentId: number;data: CustomerCategoryDocumentDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDocumentRequirement>>, TError,{categoryId: number;documentId: number;data: CustomerCategoryDocumentDTO}, TContext> => {

const mutationKey = ['updateDocumentRequirement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDocumentRequirement>>, {categoryId: number;documentId: number;data: CustomerCategoryDocumentDTO}> = (props) => {
          const {categoryId,documentId,data} = props ?? {};

          return  updateDocumentRequirement(categoryId,documentId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateDocumentRequirementMutationResult = NonNullable<Awaited<ReturnType<typeof updateDocumentRequirement>>>
    export type UpdateDocumentRequirementMutationBody = CustomerCategoryDocumentDTO
    export type UpdateDocumentRequirementMutationError = unknown

    export const useUpdateDocumentRequirement = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDocumentRequirement>>, TError,{categoryId: number;documentId: number;data: CustomerCategoryDocumentDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateDocumentRequirement>>,
        TError,
        {categoryId: number;documentId: number;data: CustomerCategoryDocumentDTO},
        TContext
      > => {

      const mutationOptions = getUpdateDocumentRequirementMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const removeDocumentRequirement = (
    categoryId: number,
    documentId: number,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<null>(
      {url: `/api/customer-categories/${categoryId}/documents/${documentId}`, method: 'DELETE'
    },
      options);
    }
  


export const getRemoveDocumentRequirementMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeDocumentRequirement>>, TError,{categoryId: number;documentId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof removeDocumentRequirement>>, TError,{categoryId: number;documentId: number}, TContext> => {

const mutationKey = ['removeDocumentRequirement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeDocumentRequirement>>, {categoryId: number;documentId: number}> = (props) => {
          const {categoryId,documentId} = props ?? {};

          return  removeDocumentRequirement(categoryId,documentId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RemoveDocumentRequirementMutationResult = NonNullable<Awaited<ReturnType<typeof removeDocumentRequirement>>>
    
    export type RemoveDocumentRequirementMutationError = unknown

    export const useRemoveDocumentRequirement = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeDocumentRequirement>>, TError,{categoryId: number;documentId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeDocumentRequirement>>,
        TError,
        {categoryId: number;documentId: number},
        TContext
      > => {

      const mutationOptions = getRemoveDocumentRequirementMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const getDataProtectionConfiguration = (
    categoryId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<DataProtectionConfiguration>(
      {url: `/api/customer-categories/${categoryId}/data-protection-configuration`, method: 'GET', signal
    },
      options);
    }
  

export const getGetDataProtectionConfigurationQueryKey = (categoryId?: number,) => {
    return [`/api/customer-categories/${categoryId}/data-protection-configuration`] as const;
    }

    
export const getGetDataProtectionConfigurationQueryOptions = <TData = Awaited<ReturnType<typeof getDataProtectionConfiguration>>, TError = unknown>(categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataProtectionConfiguration>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDataProtectionConfigurationQueryKey(categoryId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDataProtectionConfiguration>>> = ({ signal }) => getDataProtectionConfiguration(categoryId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(categoryId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDataProtectionConfiguration>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDataProtectionConfigurationQueryResult = NonNullable<Awaited<ReturnType<typeof getDataProtectionConfiguration>>>
export type GetDataProtectionConfigurationQueryError = unknown


export function useGetDataProtectionConfiguration<TData = Awaited<ReturnType<typeof getDataProtectionConfiguration>>, TError = unknown>(
 categoryId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataProtectionConfiguration>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataProtectionConfiguration>>,
          TError,
          Awaited<ReturnType<typeof getDataProtectionConfiguration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDataProtectionConfiguration<TData = Awaited<ReturnType<typeof getDataProtectionConfiguration>>, TError = unknown>(
 categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataProtectionConfiguration>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDataProtectionConfiguration>>,
          TError,
          Awaited<ReturnType<typeof getDataProtectionConfiguration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDataProtectionConfiguration<TData = Awaited<ReturnType<typeof getDataProtectionConfiguration>>, TError = unknown>(
 categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataProtectionConfiguration>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetDataProtectionConfiguration<TData = Awaited<ReturnType<typeof getDataProtectionConfiguration>>, TError = unknown>(
 categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDataProtectionConfiguration>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDataProtectionConfigurationQueryOptions(categoryId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const updateDataProtectionConfiguration = (
    categoryId: number,
    dataProtectionConfiguration: DataProtectionConfiguration,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<CustomerCategoryDTO>(
      {url: `/api/customer-categories/${categoryId}/data-protection-configuration`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: dataProtectionConfiguration
    },
      options);
    }
  


export const getUpdateDataProtectionConfigurationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDataProtectionConfiguration>>, TError,{categoryId: number;data: DataProtectionConfiguration}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDataProtectionConfiguration>>, TError,{categoryId: number;data: DataProtectionConfiguration}, TContext> => {

const mutationKey = ['updateDataProtectionConfiguration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDataProtectionConfiguration>>, {categoryId: number;data: DataProtectionConfiguration}> = (props) => {
          const {categoryId,data} = props ?? {};

          return  updateDataProtectionConfiguration(categoryId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateDataProtectionConfigurationMutationResult = NonNullable<Awaited<ReturnType<typeof updateDataProtectionConfiguration>>>
    export type UpdateDataProtectionConfigurationMutationBody = DataProtectionConfiguration
    export type UpdateDataProtectionConfigurationMutationError = unknown

    export const useUpdateDataProtectionConfiguration = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDataProtectionConfiguration>>, TError,{categoryId: number;data: DataProtectionConfiguration}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateDataProtectionConfiguration>>,
        TError,
        {categoryId: number;data: DataProtectionConfiguration},
        TContext
      > => {

      const mutationOptions = getUpdateDataProtectionConfigurationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const getAllCategories = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerCategoryDTO[]>(
      {url: `/api/customer-categories`, method: 'GET', signal
    },
      options);
    }
  

export const getGetAllCategoriesQueryKey = () => {
    return [`/api/customer-categories`] as const;
    }

    
export const getGetAllCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof getAllCategories>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllCategoriesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllCategories>>> = ({ signal }) => getAllCategories(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllCategories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof getAllCategories>>>
export type GetAllCategoriesQueryError = unknown


export function useGetAllCategories<TData = Awaited<ReturnType<typeof getAllCategories>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCategories>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllCategories>>,
          TError,
          Awaited<ReturnType<typeof getAllCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllCategories<TData = Awaited<ReturnType<typeof getAllCategories>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCategories>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllCategories>>,
          TError,
          Awaited<ReturnType<typeof getAllCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllCategories<TData = Awaited<ReturnType<typeof getAllCategories>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAllCategories<TData = Awaited<ReturnType<typeof getAllCategories>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllCategoriesQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const createCategory = (
    createCustomerCategoryDTO: CreateCustomerCategoryDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerCategoryDTO>(
      {url: `/api/customer-categories`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCustomerCategoryDTO, signal
    },
      options);
    }
  


export const getCreateCategoryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCategory>>, TError,{data: CreateCustomerCategoryDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createCategory>>, TError,{data: CreateCustomerCategoryDTO}, TContext> => {

const mutationKey = ['createCategory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCategory>>, {data: CreateCustomerCategoryDTO}> = (props) => {
          const {data} = props ?? {};

          return  createCategory(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof createCategory>>>
    export type CreateCategoryMutationBody = CreateCustomerCategoryDTO
    export type CreateCategoryMutationError = unknown

    export const useCreateCategory = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCategory>>, TError,{data: CreateCustomerCategoryDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCategory>>,
        TError,
        {data: CreateCustomerCategoryDTO},
        TContext
      > => {

      const mutationOptions = getCreateCategoryMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const getLocationRequirements = (
    categoryId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerCategoryLocationDTO[]>(
      {url: `/api/customer-categories/${categoryId}/locations`, method: 'GET', signal
    },
      options);
    }
  

export const getGetLocationRequirementsQueryKey = (categoryId?: number,) => {
    return [`/api/customer-categories/${categoryId}/locations`] as const;
    }

    
export const getGetLocationRequirementsQueryOptions = <TData = Awaited<ReturnType<typeof getLocationRequirements>>, TError = unknown>(categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationRequirements>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLocationRequirementsQueryKey(categoryId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocationRequirements>>> = ({ signal }) => getLocationRequirements(categoryId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(categoryId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLocationRequirements>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLocationRequirementsQueryResult = NonNullable<Awaited<ReturnType<typeof getLocationRequirements>>>
export type GetLocationRequirementsQueryError = unknown


export function useGetLocationRequirements<TData = Awaited<ReturnType<typeof getLocationRequirements>>, TError = unknown>(
 categoryId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationRequirements>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocationRequirements>>,
          TError,
          Awaited<ReturnType<typeof getLocationRequirements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLocationRequirements<TData = Awaited<ReturnType<typeof getLocationRequirements>>, TError = unknown>(
 categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationRequirements>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocationRequirements>>,
          TError,
          Awaited<ReturnType<typeof getLocationRequirements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLocationRequirements<TData = Awaited<ReturnType<typeof getLocationRequirements>>, TError = unknown>(
 categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationRequirements>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetLocationRequirements<TData = Awaited<ReturnType<typeof getLocationRequirements>>, TError = unknown>(
 categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationRequirements>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLocationRequirementsQueryOptions(categoryId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const addLocationRequirement = (
    categoryId: number,
    customerCategoryLocationDTO: CustomerCategoryLocationDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerCategoryLocationDTO>(
      {url: `/api/customer-categories/${categoryId}/locations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: customerCategoryLocationDTO, signal
    },
      options);
    }
  


export const getAddLocationRequirementMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addLocationRequirement>>, TError,{categoryId: number;data: CustomerCategoryLocationDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof addLocationRequirement>>, TError,{categoryId: number;data: CustomerCategoryLocationDTO}, TContext> => {

const mutationKey = ['addLocationRequirement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addLocationRequirement>>, {categoryId: number;data: CustomerCategoryLocationDTO}> = (props) => {
          const {categoryId,data} = props ?? {};

          return  addLocationRequirement(categoryId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddLocationRequirementMutationResult = NonNullable<Awaited<ReturnType<typeof addLocationRequirement>>>
    export type AddLocationRequirementMutationBody = CustomerCategoryLocationDTO
    export type AddLocationRequirementMutationError = unknown

    export const useAddLocationRequirement = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addLocationRequirement>>, TError,{categoryId: number;data: CustomerCategoryLocationDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addLocationRequirement>>,
        TError,
        {categoryId: number;data: CustomerCategoryLocationDTO},
        TContext
      > => {

      const mutationOptions = getAddLocationRequirementMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const getDocumentRequirements = (
    categoryId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerCategoryDocumentDTO[]>(
      {url: `/api/customer-categories/${categoryId}/documents`, method: 'GET', signal
    },
      options);
    }
  

export const getGetDocumentRequirementsQueryKey = (categoryId?: number,) => {
    return [`/api/customer-categories/${categoryId}/documents`] as const;
    }

    
export const getGetDocumentRequirementsQueryOptions = <TData = Awaited<ReturnType<typeof getDocumentRequirements>>, TError = unknown>(categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentRequirements>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentRequirementsQueryKey(categoryId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocumentRequirements>>> = ({ signal }) => getDocumentRequirements(categoryId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(categoryId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDocumentRequirements>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDocumentRequirementsQueryResult = NonNullable<Awaited<ReturnType<typeof getDocumentRequirements>>>
export type GetDocumentRequirementsQueryError = unknown


export function useGetDocumentRequirements<TData = Awaited<ReturnType<typeof getDocumentRequirements>>, TError = unknown>(
 categoryId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentRequirements>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentRequirements>>,
          TError,
          Awaited<ReturnType<typeof getDocumentRequirements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocumentRequirements<TData = Awaited<ReturnType<typeof getDocumentRequirements>>, TError = unknown>(
 categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentRequirements>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentRequirements>>,
          TError,
          Awaited<ReturnType<typeof getDocumentRequirements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocumentRequirements<TData = Awaited<ReturnType<typeof getDocumentRequirements>>, TError = unknown>(
 categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentRequirements>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetDocumentRequirements<TData = Awaited<ReturnType<typeof getDocumentRequirements>>, TError = unknown>(
 categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentRequirements>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDocumentRequirementsQueryOptions(categoryId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const addDocumentRequirement = (
    categoryId: number,
    customerCategoryDocumentDTO: CustomerCategoryDocumentDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerCategoryDocumentDTO>(
      {url: `/api/customer-categories/${categoryId}/documents`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: customerCategoryDocumentDTO, signal
    },
      options);
    }
  


export const getAddDocumentRequirementMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addDocumentRequirement>>, TError,{categoryId: number;data: CustomerCategoryDocumentDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof addDocumentRequirement>>, TError,{categoryId: number;data: CustomerCategoryDocumentDTO}, TContext> => {

const mutationKey = ['addDocumentRequirement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addDocumentRequirement>>, {categoryId: number;data: CustomerCategoryDocumentDTO}> = (props) => {
          const {categoryId,data} = props ?? {};

          return  addDocumentRequirement(categoryId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddDocumentRequirementMutationResult = NonNullable<Awaited<ReturnType<typeof addDocumentRequirement>>>
    export type AddDocumentRequirementMutationBody = CustomerCategoryDocumentDTO
    export type AddDocumentRequirementMutationError = unknown

    export const useAddDocumentRequirement = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addDocumentRequirement>>, TError,{categoryId: number;data: CustomerCategoryDocumentDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addDocumentRequirement>>,
        TError,
        {categoryId: number;data: CustomerCategoryDocumentDTO},
        TContext
      > => {

      const mutationOptions = getAddDocumentRequirementMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const updateCategoryStatus = (
    id: number,
    status: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<CustomerCategoryDTO>(
      {url: `/api/customer-categories/${id}/status/${status}`, method: 'PATCH'
    },
      options);
    }
  


export const getUpdateCategoryStatusMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCategoryStatus>>, TError,{id: number;status: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCategoryStatus>>, TError,{id: number;status: string}, TContext> => {

const mutationKey = ['updateCategoryStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCategoryStatus>>, {id: number;status: string}> = (props) => {
          const {id,status} = props ?? {};

          return  updateCategoryStatus(id,status,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateCategoryStatusMutationResult = NonNullable<Awaited<ReturnType<typeof updateCategoryStatus>>>
    
    export type UpdateCategoryStatusMutationError = unknown

    export const useUpdateCategoryStatus = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCategoryStatus>>, TError,{id: number;status: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateCategoryStatus>>,
        TError,
        {id: number;status: string},
        TContext
      > => {

      const mutationOptions = getUpdateCategoryStatusMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const getSubPartCategories = (
    parentCategoryId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerCategoryDTO[]>(
      {url: `/api/customer-categories/${parentCategoryId}/sub-parts`, method: 'GET', signal
    },
      options);
    }
  

export const getGetSubPartCategoriesQueryKey = (parentCategoryId?: number,) => {
    return [`/api/customer-categories/${parentCategoryId}/sub-parts`] as const;
    }

    
export const getGetSubPartCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof getSubPartCategories>>, TError = unknown>(parentCategoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubPartCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSubPartCategoriesQueryKey(parentCategoryId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubPartCategories>>> = ({ signal }) => getSubPartCategories(parentCategoryId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(parentCategoryId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSubPartCategories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetSubPartCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof getSubPartCategories>>>
export type GetSubPartCategoriesQueryError = unknown


export function useGetSubPartCategories<TData = Awaited<ReturnType<typeof getSubPartCategories>>, TError = unknown>(
 parentCategoryId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubPartCategories>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubPartCategories>>,
          TError,
          Awaited<ReturnType<typeof getSubPartCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSubPartCategories<TData = Awaited<ReturnType<typeof getSubPartCategories>>, TError = unknown>(
 parentCategoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubPartCategories>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubPartCategories>>,
          TError,
          Awaited<ReturnType<typeof getSubPartCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSubPartCategories<TData = Awaited<ReturnType<typeof getSubPartCategories>>, TError = unknown>(
 parentCategoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubPartCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetSubPartCategories<TData = Awaited<ReturnType<typeof getSubPartCategories>>, TError = unknown>(
 parentCategoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubPartCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetSubPartCategoriesQueryOptions(parentCategoryId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getSubPartCategoriesByType = (
    parentCategoryId: number,
    subPartType: SubPartType,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerCategoryDTO[]>(
      {url: `/api/customer-categories/${parentCategoryId}/sub-parts/${subPartType}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetSubPartCategoriesByTypeQueryKey = (parentCategoryId?: number,
    subPartType?: SubPartType,) => {
    return [`/api/customer-categories/${parentCategoryId}/sub-parts/${subPartType}`] as const;
    }

    
export const getGetSubPartCategoriesByTypeQueryOptions = <TData = Awaited<ReturnType<typeof getSubPartCategoriesByType>>, TError = unknown>(parentCategoryId: number,
    subPartType: SubPartType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubPartCategoriesByType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSubPartCategoriesByTypeQueryKey(parentCategoryId,subPartType);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubPartCategoriesByType>>> = ({ signal }) => getSubPartCategoriesByType(parentCategoryId,subPartType, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(parentCategoryId && subPartType), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSubPartCategoriesByType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetSubPartCategoriesByTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getSubPartCategoriesByType>>>
export type GetSubPartCategoriesByTypeQueryError = unknown


export function useGetSubPartCategoriesByType<TData = Awaited<ReturnType<typeof getSubPartCategoriesByType>>, TError = unknown>(
 parentCategoryId: number,
    subPartType: SubPartType, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubPartCategoriesByType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubPartCategoriesByType>>,
          TError,
          Awaited<ReturnType<typeof getSubPartCategoriesByType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSubPartCategoriesByType<TData = Awaited<ReturnType<typeof getSubPartCategoriesByType>>, TError = unknown>(
 parentCategoryId: number,
    subPartType: SubPartType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubPartCategoriesByType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubPartCategoriesByType>>,
          TError,
          Awaited<ReturnType<typeof getSubPartCategoriesByType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSubPartCategoriesByType<TData = Awaited<ReturnType<typeof getSubPartCategoriesByType>>, TError = unknown>(
 parentCategoryId: number,
    subPartType: SubPartType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubPartCategoriesByType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetSubPartCategoriesByType<TData = Awaited<ReturnType<typeof getSubPartCategoriesByType>>, TError = unknown>(
 parentCategoryId: number,
    subPartType: SubPartType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubPartCategoriesByType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetSubPartCategoriesByTypeQueryOptions(parentCategoryId,subPartType,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCategoryUserGroups = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerCategoryUserGroupDTO[]>(
      {url: `/api/customer-categories/${id}/user-groups`, method: 'GET', signal
    },
      options);
    }
  

export const getGetCategoryUserGroupsQueryKey = (id?: number,) => {
    return [`/api/customer-categories/${id}/user-groups`] as const;
    }

    
export const getGetCategoryUserGroupsQueryOptions = <TData = Awaited<ReturnType<typeof getCategoryUserGroups>>, TError = unknown>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryUserGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCategoryUserGroupsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCategoryUserGroups>>> = ({ signal }) => getCategoryUserGroups(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCategoryUserGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCategoryUserGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof getCategoryUserGroups>>>
export type GetCategoryUserGroupsQueryError = unknown


export function useGetCategoryUserGroups<TData = Awaited<ReturnType<typeof getCategoryUserGroups>>, TError = unknown>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryUserGroups>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategoryUserGroups>>,
          TError,
          Awaited<ReturnType<typeof getCategoryUserGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCategoryUserGroups<TData = Awaited<ReturnType<typeof getCategoryUserGroups>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryUserGroups>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategoryUserGroups>>,
          TError,
          Awaited<ReturnType<typeof getCategoryUserGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCategoryUserGroups<TData = Awaited<ReturnType<typeof getCategoryUserGroups>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryUserGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCategoryUserGroups<TData = Awaited<ReturnType<typeof getCategoryUserGroups>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryUserGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCategoryUserGroupsQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCategoryProducts = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerCategoryProductDTO[]>(
      {url: `/api/customer-categories/${id}/products`, method: 'GET', signal
    },
      options);
    }
  

export const getGetCategoryProductsQueryKey = (id?: number,) => {
    return [`/api/customer-categories/${id}/products`] as const;
    }

    
export const getGetCategoryProductsQueryOptions = <TData = Awaited<ReturnType<typeof getCategoryProducts>>, TError = unknown>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryProducts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCategoryProductsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCategoryProducts>>> = ({ signal }) => getCategoryProducts(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCategoryProducts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCategoryProductsQueryResult = NonNullable<Awaited<ReturnType<typeof getCategoryProducts>>>
export type GetCategoryProductsQueryError = unknown


export function useGetCategoryProducts<TData = Awaited<ReturnType<typeof getCategoryProducts>>, TError = unknown>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryProducts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategoryProducts>>,
          TError,
          Awaited<ReturnType<typeof getCategoryProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCategoryProducts<TData = Awaited<ReturnType<typeof getCategoryProducts>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryProducts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategoryProducts>>,
          TError,
          Awaited<ReturnType<typeof getCategoryProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCategoryProducts<TData = Awaited<ReturnType<typeof getCategoryProducts>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryProducts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCategoryProducts<TData = Awaited<ReturnType<typeof getCategoryProducts>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryProducts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCategoryProductsQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCategoryGroupConfig = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerCategoryGroupConfigDTO>(
      {url: `/api/customer-categories/${id}/group-config`, method: 'GET', signal
    },
      options);
    }
  

export const getGetCategoryGroupConfigQueryKey = (id?: number,) => {
    return [`/api/customer-categories/${id}/group-config`] as const;
    }

    
export const getGetCategoryGroupConfigQueryOptions = <TData = Awaited<ReturnType<typeof getCategoryGroupConfig>>, TError = unknown>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryGroupConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCategoryGroupConfigQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCategoryGroupConfig>>> = ({ signal }) => getCategoryGroupConfig(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCategoryGroupConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCategoryGroupConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getCategoryGroupConfig>>>
export type GetCategoryGroupConfigQueryError = unknown


export function useGetCategoryGroupConfig<TData = Awaited<ReturnType<typeof getCategoryGroupConfig>>, TError = unknown>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryGroupConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategoryGroupConfig>>,
          TError,
          Awaited<ReturnType<typeof getCategoryGroupConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCategoryGroupConfig<TData = Awaited<ReturnType<typeof getCategoryGroupConfig>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryGroupConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategoryGroupConfig>>,
          TError,
          Awaited<ReturnType<typeof getCategoryGroupConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCategoryGroupConfig<TData = Awaited<ReturnType<typeof getCategoryGroupConfig>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryGroupConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCategoryGroupConfig<TData = Awaited<ReturnType<typeof getCategoryGroupConfig>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryGroupConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCategoryGroupConfigQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCategoryFields = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerCategoryFieldDTO[]>(
      {url: `/api/customer-categories/${id}/fields`, method: 'GET', signal
    },
      options);
    }
  

export const getGetCategoryFieldsQueryKey = (id?: number,) => {
    return [`/api/customer-categories/${id}/fields`] as const;
    }

    
export const getGetCategoryFieldsQueryOptions = <TData = Awaited<ReturnType<typeof getCategoryFields>>, TError = unknown>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryFields>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCategoryFieldsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCategoryFields>>> = ({ signal }) => getCategoryFields(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCategoryFields>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCategoryFieldsQueryResult = NonNullable<Awaited<ReturnType<typeof getCategoryFields>>>
export type GetCategoryFieldsQueryError = unknown


export function useGetCategoryFields<TData = Awaited<ReturnType<typeof getCategoryFields>>, TError = unknown>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryFields>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategoryFields>>,
          TError,
          Awaited<ReturnType<typeof getCategoryFields>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCategoryFields<TData = Awaited<ReturnType<typeof getCategoryFields>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryFields>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategoryFields>>,
          TError,
          Awaited<ReturnType<typeof getCategoryFields>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCategoryFields<TData = Awaited<ReturnType<typeof getCategoryFields>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryFields>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCategoryFields<TData = Awaited<ReturnType<typeof getCategoryFields>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryFields>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCategoryFieldsQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCategoryFieldsByEntityType = (
    id: number,
    entityType: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerCategoryFieldDTO[]>(
      {url: `/api/customer-categories/${id}/fields/${entityType}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetCategoryFieldsByEntityTypeQueryKey = (id?: number,
    entityType?: string,) => {
    return [`/api/customer-categories/${id}/fields/${entityType}`] as const;
    }

    
export const getGetCategoryFieldsByEntityTypeQueryOptions = <TData = Awaited<ReturnType<typeof getCategoryFieldsByEntityType>>, TError = unknown>(id: number,
    entityType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryFieldsByEntityType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCategoryFieldsByEntityTypeQueryKey(id,entityType);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCategoryFieldsByEntityType>>> = ({ signal }) => getCategoryFieldsByEntityType(id,entityType, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id && entityType), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCategoryFieldsByEntityType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCategoryFieldsByEntityTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getCategoryFieldsByEntityType>>>
export type GetCategoryFieldsByEntityTypeQueryError = unknown


export function useGetCategoryFieldsByEntityType<TData = Awaited<ReturnType<typeof getCategoryFieldsByEntityType>>, TError = unknown>(
 id: number,
    entityType: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryFieldsByEntityType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategoryFieldsByEntityType>>,
          TError,
          Awaited<ReturnType<typeof getCategoryFieldsByEntityType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCategoryFieldsByEntityType<TData = Awaited<ReturnType<typeof getCategoryFieldsByEntityType>>, TError = unknown>(
 id: number,
    entityType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryFieldsByEntityType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategoryFieldsByEntityType>>,
          TError,
          Awaited<ReturnType<typeof getCategoryFieldsByEntityType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCategoryFieldsByEntityType<TData = Awaited<ReturnType<typeof getCategoryFieldsByEntityType>>, TError = unknown>(
 id: number,
    entityType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryFieldsByEntityType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCategoryFieldsByEntityType<TData = Awaited<ReturnType<typeof getCategoryFieldsByEntityType>>, TError = unknown>(
 id: number,
    entityType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryFieldsByEntityType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCategoryFieldsByEntityTypeQueryOptions(id,entityType,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCategoryBusinessConfig = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerCategoryBusinessConfigDTO>(
      {url: `/api/customer-categories/${id}/business-config`, method: 'GET', signal
    },
      options);
    }
  

export const getGetCategoryBusinessConfigQueryKey = (id?: number,) => {
    return [`/api/customer-categories/${id}/business-config`] as const;
    }

    
export const getGetCategoryBusinessConfigQueryOptions = <TData = Awaited<ReturnType<typeof getCategoryBusinessConfig>>, TError = unknown>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryBusinessConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCategoryBusinessConfigQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCategoryBusinessConfig>>> = ({ signal }) => getCategoryBusinessConfig(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCategoryBusinessConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCategoryBusinessConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getCategoryBusinessConfig>>>
export type GetCategoryBusinessConfigQueryError = unknown


export function useGetCategoryBusinessConfig<TData = Awaited<ReturnType<typeof getCategoryBusinessConfig>>, TError = unknown>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryBusinessConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategoryBusinessConfig>>,
          TError,
          Awaited<ReturnType<typeof getCategoryBusinessConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCategoryBusinessConfig<TData = Awaited<ReturnType<typeof getCategoryBusinessConfig>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryBusinessConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategoryBusinessConfig>>,
          TError,
          Awaited<ReturnType<typeof getCategoryBusinessConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCategoryBusinessConfig<TData = Awaited<ReturnType<typeof getCategoryBusinessConfig>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryBusinessConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCategoryBusinessConfig<TData = Awaited<ReturnType<typeof getCategoryBusinessConfig>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryBusinessConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCategoryBusinessConfigQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getRequiredLocations = (
    categoryId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerCategoryLocationDTO[]>(
      {url: `/api/customer-categories/${categoryId}/locations/required`, method: 'GET', signal
    },
      options);
    }
  

export const getGetRequiredLocationsQueryKey = (categoryId?: number,) => {
    return [`/api/customer-categories/${categoryId}/locations/required`] as const;
    }

    
export const getGetRequiredLocationsQueryOptions = <TData = Awaited<ReturnType<typeof getRequiredLocations>>, TError = unknown>(categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequiredLocations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRequiredLocationsQueryKey(categoryId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequiredLocations>>> = ({ signal }) => getRequiredLocations(categoryId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(categoryId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRequiredLocations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetRequiredLocationsQueryResult = NonNullable<Awaited<ReturnType<typeof getRequiredLocations>>>
export type GetRequiredLocationsQueryError = unknown


export function useGetRequiredLocations<TData = Awaited<ReturnType<typeof getRequiredLocations>>, TError = unknown>(
 categoryId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequiredLocations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRequiredLocations>>,
          TError,
          Awaited<ReturnType<typeof getRequiredLocations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRequiredLocations<TData = Awaited<ReturnType<typeof getRequiredLocations>>, TError = unknown>(
 categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequiredLocations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRequiredLocations>>,
          TError,
          Awaited<ReturnType<typeof getRequiredLocations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRequiredLocations<TData = Awaited<ReturnType<typeof getRequiredLocations>>, TError = unknown>(
 categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequiredLocations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetRequiredLocations<TData = Awaited<ReturnType<typeof getRequiredLocations>>, TError = unknown>(
 categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequiredLocations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetRequiredLocationsQueryOptions(categoryId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPrimaryLocation = (
    categoryId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerCategoryLocationDTO>(
      {url: `/api/customer-categories/${categoryId}/locations/primary`, method: 'GET', signal
    },
      options);
    }
  

export const getGetPrimaryLocationQueryKey = (categoryId?: number,) => {
    return [`/api/customer-categories/${categoryId}/locations/primary`] as const;
    }

    
export const getGetPrimaryLocationQueryOptions = <TData = Awaited<ReturnType<typeof getPrimaryLocation>>, TError = unknown>(categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPrimaryLocation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPrimaryLocationQueryKey(categoryId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPrimaryLocation>>> = ({ signal }) => getPrimaryLocation(categoryId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(categoryId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPrimaryLocation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetPrimaryLocationQueryResult = NonNullable<Awaited<ReturnType<typeof getPrimaryLocation>>>
export type GetPrimaryLocationQueryError = unknown


export function useGetPrimaryLocation<TData = Awaited<ReturnType<typeof getPrimaryLocation>>, TError = unknown>(
 categoryId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPrimaryLocation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPrimaryLocation>>,
          TError,
          Awaited<ReturnType<typeof getPrimaryLocation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPrimaryLocation<TData = Awaited<ReturnType<typeof getPrimaryLocation>>, TError = unknown>(
 categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPrimaryLocation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPrimaryLocation>>,
          TError,
          Awaited<ReturnType<typeof getPrimaryLocation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPrimaryLocation<TData = Awaited<ReturnType<typeof getPrimaryLocation>>, TError = unknown>(
 categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPrimaryLocation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetPrimaryLocation<TData = Awaited<ReturnType<typeof getPrimaryLocation>>, TError = unknown>(
 categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPrimaryLocation>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetPrimaryLocationQueryOptions(categoryId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getRequiredDocuments = (
    categoryId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerCategoryDocumentDTO[]>(
      {url: `/api/customer-categories/${categoryId}/documents/required`, method: 'GET', signal
    },
      options);
    }
  

export const getGetRequiredDocumentsQueryKey = (categoryId?: number,) => {
    return [`/api/customer-categories/${categoryId}/documents/required`] as const;
    }

    
export const getGetRequiredDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof getRequiredDocuments>>, TError = unknown>(categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequiredDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRequiredDocumentsQueryKey(categoryId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequiredDocuments>>> = ({ signal }) => getRequiredDocuments(categoryId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(categoryId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRequiredDocuments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetRequiredDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof getRequiredDocuments>>>
export type GetRequiredDocumentsQueryError = unknown


export function useGetRequiredDocuments<TData = Awaited<ReturnType<typeof getRequiredDocuments>>, TError = unknown>(
 categoryId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequiredDocuments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRequiredDocuments>>,
          TError,
          Awaited<ReturnType<typeof getRequiredDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRequiredDocuments<TData = Awaited<ReturnType<typeof getRequiredDocuments>>, TError = unknown>(
 categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequiredDocuments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRequiredDocuments>>,
          TError,
          Awaited<ReturnType<typeof getRequiredDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRequiredDocuments<TData = Awaited<ReturnType<typeof getRequiredDocuments>>, TError = unknown>(
 categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequiredDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetRequiredDocuments<TData = Awaited<ReturnType<typeof getRequiredDocuments>>, TError = unknown>(
 categoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequiredDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetRequiredDocumentsQueryOptions(categoryId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCategoriesForUserGroup = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<UserCategoryAccessDTO>(
      {url: `/api/customer-categories/user-group`, method: 'GET', signal
    },
      options);
    }
  

export const getGetCategoriesForUserGroupQueryKey = () => {
    return [`/api/customer-categories/user-group`] as const;
    }

    
export const getGetCategoriesForUserGroupQueryOptions = <TData = Awaited<ReturnType<typeof getCategoriesForUserGroup>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoriesForUserGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCategoriesForUserGroupQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCategoriesForUserGroup>>> = ({ signal }) => getCategoriesForUserGroup(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCategoriesForUserGroup>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCategoriesForUserGroupQueryResult = NonNullable<Awaited<ReturnType<typeof getCategoriesForUserGroup>>>
export type GetCategoriesForUserGroupQueryError = unknown


export function useGetCategoriesForUserGroup<TData = Awaited<ReturnType<typeof getCategoriesForUserGroup>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoriesForUserGroup>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategoriesForUserGroup>>,
          TError,
          Awaited<ReturnType<typeof getCategoriesForUserGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCategoriesForUserGroup<TData = Awaited<ReturnType<typeof getCategoriesForUserGroup>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoriesForUserGroup>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategoriesForUserGroup>>,
          TError,
          Awaited<ReturnType<typeof getCategoriesForUserGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCategoriesForUserGroup<TData = Awaited<ReturnType<typeof getCategoriesForUserGroup>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoriesForUserGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCategoriesForUserGroup<TData = Awaited<ReturnType<typeof getCategoriesForUserGroup>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoriesForUserGroup>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCategoriesForUserGroupQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAllSubPartTypes = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SubPartType[]>(
      {url: `/api/customer-categories/sub-part-types`, method: 'GET', signal
    },
      options);
    }
  

export const getGetAllSubPartTypesQueryKey = () => {
    return [`/api/customer-categories/sub-part-types`] as const;
    }

    
export const getGetAllSubPartTypesQueryOptions = <TData = Awaited<ReturnType<typeof getAllSubPartTypes>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllSubPartTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllSubPartTypesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllSubPartTypes>>> = ({ signal }) => getAllSubPartTypes(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllSubPartTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllSubPartTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getAllSubPartTypes>>>
export type GetAllSubPartTypesQueryError = unknown


export function useGetAllSubPartTypes<TData = Awaited<ReturnType<typeof getAllSubPartTypes>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllSubPartTypes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllSubPartTypes>>,
          TError,
          Awaited<ReturnType<typeof getAllSubPartTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllSubPartTypes<TData = Awaited<ReturnType<typeof getAllSubPartTypes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllSubPartTypes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllSubPartTypes>>,
          TError,
          Awaited<ReturnType<typeof getAllSubPartTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllSubPartTypes<TData = Awaited<ReturnType<typeof getAllSubPartTypes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllSubPartTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAllSubPartTypes<TData = Awaited<ReturnType<typeof getAllSubPartTypes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllSubPartTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllSubPartTypesQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAvailableSubPartTypes = (
    customerType: CustomerType,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SubPartType[]>(
      {url: `/api/customer-categories/sub-part-types/${customerType}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetAvailableSubPartTypesQueryKey = (customerType?: CustomerType,) => {
    return [`/api/customer-categories/sub-part-types/${customerType}`] as const;
    }

    
export const getGetAvailableSubPartTypesQueryOptions = <TData = Awaited<ReturnType<typeof getAvailableSubPartTypes>>, TError = unknown>(customerType: CustomerType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableSubPartTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAvailableSubPartTypesQueryKey(customerType);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAvailableSubPartTypes>>> = ({ signal }) => getAvailableSubPartTypes(customerType, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(customerType), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAvailableSubPartTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAvailableSubPartTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getAvailableSubPartTypes>>>
export type GetAvailableSubPartTypesQueryError = unknown


export function useGetAvailableSubPartTypes<TData = Awaited<ReturnType<typeof getAvailableSubPartTypes>>, TError = unknown>(
 customerType: CustomerType, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableSubPartTypes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAvailableSubPartTypes>>,
          TError,
          Awaited<ReturnType<typeof getAvailableSubPartTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAvailableSubPartTypes<TData = Awaited<ReturnType<typeof getAvailableSubPartTypes>>, TError = unknown>(
 customerType: CustomerType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableSubPartTypes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAvailableSubPartTypes>>,
          TError,
          Awaited<ReturnType<typeof getAvailableSubPartTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAvailableSubPartTypes<TData = Awaited<ReturnType<typeof getAvailableSubPartTypes>>, TError = unknown>(
 customerType: CustomerType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableSubPartTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAvailableSubPartTypes<TData = Awaited<ReturnType<typeof getAvailableSubPartTypes>>, TError = unknown>(
 customerType: CustomerType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailableSubPartTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAvailableSubPartTypesQueryOptions(customerType,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getMemberTemplateCategories = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerCategoryDTO[]>(
      {url: `/api/customer-categories/member-templates`, method: 'GET', signal
    },
      options);
    }
  

export const getGetMemberTemplateCategoriesQueryKey = () => {
    return [`/api/customer-categories/member-templates`] as const;
    }

    
export const getGetMemberTemplateCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof getMemberTemplateCategories>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberTemplateCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMemberTemplateCategoriesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMemberTemplateCategories>>> = ({ signal }) => getMemberTemplateCategories(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMemberTemplateCategories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetMemberTemplateCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof getMemberTemplateCategories>>>
export type GetMemberTemplateCategoriesQueryError = unknown


export function useGetMemberTemplateCategories<TData = Awaited<ReturnType<typeof getMemberTemplateCategories>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberTemplateCategories>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemberTemplateCategories>>,
          TError,
          Awaited<ReturnType<typeof getMemberTemplateCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMemberTemplateCategories<TData = Awaited<ReturnType<typeof getMemberTemplateCategories>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberTemplateCategories>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemberTemplateCategories>>,
          TError,
          Awaited<ReturnType<typeof getMemberTemplateCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMemberTemplateCategories<TData = Awaited<ReturnType<typeof getMemberTemplateCategories>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberTemplateCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetMemberTemplateCategories<TData = Awaited<ReturnType<typeof getMemberTemplateCategories>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberTemplateCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetMemberTemplateCategoriesQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getMainEntityCategories = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerCategoryDTO[]>(
      {url: `/api/customer-categories/main-entities`, method: 'GET', signal
    },
      options);
    }
  

export const getGetMainEntityCategoriesQueryKey = () => {
    return [`/api/customer-categories/main-entities`] as const;
    }

    
export const getGetMainEntityCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof getMainEntityCategories>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMainEntityCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMainEntityCategoriesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMainEntityCategories>>> = ({ signal }) => getMainEntityCategories(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMainEntityCategories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetMainEntityCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof getMainEntityCategories>>>
export type GetMainEntityCategoriesQueryError = unknown


export function useGetMainEntityCategories<TData = Awaited<ReturnType<typeof getMainEntityCategories>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMainEntityCategories>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMainEntityCategories>>,
          TError,
          Awaited<ReturnType<typeof getMainEntityCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMainEntityCategories<TData = Awaited<ReturnType<typeof getMainEntityCategories>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMainEntityCategories>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMainEntityCategories>>,
          TError,
          Awaited<ReturnType<typeof getMainEntityCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMainEntityCategories<TData = Awaited<ReturnType<typeof getMainEntityCategories>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMainEntityCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetMainEntityCategories<TData = Awaited<ReturnType<typeof getMainEntityCategories>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMainEntityCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetMainEntityCategoriesQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCustomerTypes = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerType[]>(
      {url: `/api/customer-categories/customer-types`, method: 'GET', signal
    },
      options);
    }
  

export const getGetCustomerTypesQueryKey = () => {
    return [`/api/customer-categories/customer-types`] as const;
    }

    
export const getGetCustomerTypesQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerTypes>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerTypesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerTypes>>> = ({ signal }) => getCustomerTypes(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCustomerTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerTypes>>>
export type GetCustomerTypesQueryError = unknown


export function useGetCustomerTypes<TData = Awaited<ReturnType<typeof getCustomerTypes>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerTypes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerTypes>>,
          TError,
          Awaited<ReturnType<typeof getCustomerTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCustomerTypes<TData = Awaited<ReturnType<typeof getCustomerTypes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerTypes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerTypes>>,
          TError,
          Awaited<ReturnType<typeof getCustomerTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCustomerTypes<TData = Awaited<ReturnType<typeof getCustomerTypes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCustomerTypes<TData = Awaited<ReturnType<typeof getCustomerTypes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCustomerTypesQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCategoriesByType = (
    customerType: CustomerType,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerCategoryDTO[]>(
      {url: `/api/customer-categories/by-type/${customerType}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetCategoriesByTypeQueryKey = (customerType?: CustomerType,) => {
    return [`/api/customer-categories/by-type/${customerType}`] as const;
    }

    
export const getGetCategoriesByTypeQueryOptions = <TData = Awaited<ReturnType<typeof getCategoriesByType>>, TError = unknown>(customerType: CustomerType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoriesByType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCategoriesByTypeQueryKey(customerType);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCategoriesByType>>> = ({ signal }) => getCategoriesByType(customerType, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(customerType), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCategoriesByType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCategoriesByTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getCategoriesByType>>>
export type GetCategoriesByTypeQueryError = unknown


export function useGetCategoriesByType<TData = Awaited<ReturnType<typeof getCategoriesByType>>, TError = unknown>(
 customerType: CustomerType, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoriesByType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategoriesByType>>,
          TError,
          Awaited<ReturnType<typeof getCategoriesByType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCategoriesByType<TData = Awaited<ReturnType<typeof getCategoriesByType>>, TError = unknown>(
 customerType: CustomerType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoriesByType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategoriesByType>>,
          TError,
          Awaited<ReturnType<typeof getCategoriesByType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCategoriesByType<TData = Awaited<ReturnType<typeof getCategoriesByType>>, TError = unknown>(
 customerType: CustomerType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoriesByType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCategoriesByType<TData = Awaited<ReturnType<typeof getCategoriesByType>>, TError = unknown>(
 customerType: CustomerType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoriesByType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCategoriesByTypeQueryOptions(customerType,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getActiveCategories = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerCategoryDTO[]>(
      {url: `/api/customer-categories/active`, method: 'GET', signal
    },
      options);
    }
  

export const getGetActiveCategoriesQueryKey = () => {
    return [`/api/customer-categories/active`] as const;
    }

    
export const getGetActiveCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof getActiveCategories>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActiveCategoriesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActiveCategories>>> = ({ signal }) => getActiveCategories(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActiveCategories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetActiveCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof getActiveCategories>>>
export type GetActiveCategoriesQueryError = unknown


export function useGetActiveCategories<TData = Awaited<ReturnType<typeof getActiveCategories>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveCategories>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveCategories>>,
          TError,
          Awaited<ReturnType<typeof getActiveCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActiveCategories<TData = Awaited<ReturnType<typeof getActiveCategories>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveCategories>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveCategories>>,
          TError,
          Awaited<ReturnType<typeof getActiveCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActiveCategories<TData = Awaited<ReturnType<typeof getActiveCategories>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetActiveCategories<TData = Awaited<ReturnType<typeof getActiveCategories>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetActiveCategoriesQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



